import { createAction } from 'redux-actions';

export interface setTopupAction {
	payload: {
		topupValue: number;
		selectedNumbers: any;
	};
}

export const setTopup: any = createAction('SET_TOPUP', (topup: setTopupAction) => topup);
export const clearTopup: any = createAction('CLEAR_TOPUP', () => null);
